<template>
  <div class="singleReport">     
      <md-empty-state v-if="!foods.length"
            md-icon="lock"
            md-label="Nothing to see here."
            md-description="This report either doesn't exist, or it doesn't belong to you.">
      </md-empty-state>   

<md-table style="margin-top:40px;" v-if="foods.length">
      <md-table-toolbar style="border-bottom:1px solid #333;">
      <div class="md-title">Single Report: Snacks Only</div>  
        <md-button v-on:click="downloadCSV" class="md-primary md-fab">
          <md-icon>cloud_download</md-icon>
        </md-button>
      </md-table-toolbar>
      
    <md-table-row>
      <md-table-head>UPC</md-table-head>
      <md-table-head>Food</md-table-head>
      <md-table-head>SWAP Rank</md-table-head>
      <md-table-head>Sugar</md-table-head>
      <md-table-head>Sodium</md-table-head>
      <md-table-head>SatFat</md-table-head>
    </md-table-row>

    <md-table-row v-bind:key="index" v-for="(food, index) in foods" >
      <md-table-cell>{{food.upc}}</md-table-cell>
      <md-table-cell>{{food.item_name}}</md-table-cell>

      <md-table-cell>
        {{food.rankings.swap.rank}}
      </md-table-cell>
<md-table-cell>{{food.nutrition_facts.nf_sugars}}</md-table-cell>
<md-table-cell>{{food.nutrition_facts.nf_sodium}}</md-table-cell>
<md-table-cell>{{food.nutrition_facts.nf_saturated_fat}}</md-table-cell>



    </md-table-row>
  </md-table>      
       <!-- <h1 v-bind:key="index" v-for="(food, index) in myCart.items">{{food.item_name}}</h1> -->

  </div>
</template>

<script>
import * as firebase from 'firebase/app';
import 'firebase/firestore';

export default {
  name: 'SnacksView',
  data () {
    return {
       foods:[]
    }
  },
  computed: {

  },

  methods: {
      report: function (){
                let that = this;
                var db = firebase.firestore();
                var ret = [];
                db.collection("WellScanGlobal").where("rankings.swap.category", "==", "snack-dessert")
                .get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        ret.push(doc.data());
                    });
                    that.foods = ret;
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });
            
      },


    ConvertToCSV(objArray) {
            var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
            var str = '';

            for (var i = 0; i < array.length; i++) {
                var line = '';
                for (var index in array[i]) {
                    if (line != '') line += ','

                    line += array[i][index];
                }

                str += line + '\r\n';
            }

            return str;
        },

      downloadCSV: function() {

        var items = this.foods;
        var exp = [];
         
        for (var i = 0; i < items.length; i++) {
            var row = items[i];
            if (!row.item_name)
                row.item_name = " ";
            exp.push ({
                food:row.item_name.replace(/,/g, ''),
                upc: row.upc,
                category:row.rankings.swap.category,
                rank:row.rankings.swap.rank,
                sugar:row.nutrition_facts.nf_sugars,
                sodium: row.nutrition_facts.nf_sodium,
                satfat: row.nutrition_facts.nf_saturated_fat
            });
        }
        
        exp.unshift(["Food Name", "UPC", "Category", "Rank", "Sugar", "Sodium", "Satfat"]);

        
        let csvContent = "data:text/csv;charset=utf-8,"
         csvContent += this.ConvertToCSV(exp);


         var encodedUri = encodeURI(csvContent);
          var link = document.createElement('a');
        link.setAttribute('href',encodedUri);
        link.setAttribute('download', "cart.csv");
        link.click();
         //window.open(encodedUri, "_blank");

      }

  },

  mounted: function () {
      this.report();
  }
}

</script>
